<template>
  <div>


    <!-- Subscription overlay -->
    <b-overlay
      :show="show"
      variant="transparent"
      :opacity="1"
      blur="3px"
    >
      <template v-slot:overlay>
        <div class="text-center">
          <p id="cancel-label">
            Please upgrade your subscription to activate this feature
          </p>
          <b-button
            ref="cancel"
            variant="primary"
            aria-describedby="cancel-label"
            @click="upgradeSubscription()"
          >
            Click here to upgrade
          </b-button>
        </div>
      </template>

      <b-row>
        <b-col md="9">
          <h4 class="font-weight-bold ml-1">FLS</h4>
        </b-col>

        <b-col md="1">
          <div class="float-right">
            <label class="nav-item navbar-text navbar-search-box p-0 active">
              <i class="ion ion-ios-search navbar-icon align-middle"></i>
              <span class="navbar-search-input pl-2">
                <b-form-input
                  class="ml-2"
                  v-model="filter"
                  placeholder="Search"
                ></b-form-input>
              </span>
            </label>
          </div>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        caption-top
        stacked="sm"
        :items="flushlogs"
        :fields="fields"
        :total-rows="totalRows"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :tbody-tr-class="rowCompleted"
        empty-text="There are no FLS logs to show"
      >
        <template v-slot:table-caption>Total: {{ flushlogs.length | numeralFormat }}
        </template>

        <template v-slot:cell(ordertitle)="data">
          {{ data.item.ordernumber }} - {{ data.item.customer }} ({{
            data.item.site
          }})
        </template>

        <template v-slot:cell(regtime)="data">
          {{ $date(data.value).format("DD.MM.YYYY HH:mm") }}
        </template>

        <template v-slot:cell(from_cage)="data">
          {{ data.value }}
        </template>

        <template v-slot:cell(to_cage)="data">
          {{ data.value }}
        </template>

        <template v-slot:cell(ejector)="data">
          {{ data.item.data.line1_ejector }} <span v-if="data.item.lines >= 2">/</span>
          {{ data.item.data.line2_ejector }} <span v-if="data.item.lines >= 3">/</span>
          {{ data.item.data.line3_ejector }} <span v-if="data.item.lines >= 4">/</span>
          {{ data.item.data.line4_ejector }}
        </template>

        <template v-slot:cell(flushpressure)="data">
          {{ data.item.data.line1_flushpressure }} <span v-if="data.item.lines >= 2">/</span>
          {{ data.item.data.line2_flushpressure }} <span v-if="data.item.lines >= 3">/</span>
          {{ data.item.data.line3_flushpressure }} <span v-if="data.item.lines >= 4">/</span>
          {{ data.item.data.line4_flushpressure }}
        </template>

        <template v-slot:cell(extrasuction)="data">
          {{ data.item.data.line1_extrasuction }} <span v-if="data.item.lines >= 2">/</span>
          {{ data.item.data.line2_extrasuction }} <span v-if="data.item.lines >= 3">/</span>
          {{ data.item.data.line3_extrasuction }} <span v-if="data.item.lines >= 4">/</span>
          {{ data.item.data.line4_extrasuction }}
        </template>

        <template v-slot:cell(oxygen)="data">
          {{ data.item.data.line1_oxygen }} <span v-if="data.item.lines >= 2">/</span>
          {{ data.item.data.line2_oxygen }} <span v-if="data.item.lines >= 3">/</span>
          {{ data.item.data.line3_oxygen }} <span v-if="data.item.lines >= 4">/</span>
          {{ data.item.data.line4_oxygen }}
        </template>

        <template v-slot:cell(fishcount)="data">
          {{ data.value | numeralFormat("0,0[.]00") }}
        </template>

        <template v-slot:cell(completed)="data">
          <span
            class="dot text-centre"
            v-if="data.item.completed == true"
          ></span>
        </template>
      </b-table>

      <b-row>
        <b-col
          md="1"
          class="my-1"
        >
          <b-form-group class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col
          md="2"
          class="my-1"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>

      <br />

      <b-row> </b-row>

      <!-- Info modal -->
      <b-modal
        :id="infoModal.id"
        :title="infoModal.title"
        ok-only
        @hide="resetInfoModal"
      >
        <pre>{{ infoModal.content }}</pre>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import axios from "axios";

import Vue2Filters from "vue2-filters";
import Datepicker from "vuejs-datepicker";
import VueMoment from "vue-moment";
import moment from "moment";



export default {
  components: {
    
    Datepicker,
    VueMoment,
    moment,
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      flushlogs: [],
      lastUpdate: {},
      fromDate: {},
      toDate: {},
      disabledDates: {},
      fields: [
        {
          key: "regtime",
          label: "Tidspunkt",
          sortable: true,
        },
        { key: "ordertitle", label: "Ordre", sortable: true },
        {
          key: "from_cage",
          label: "Fra merd",
          sortable: true,
        },
        {
          key: "to_cage",
          label: "Til merd",
          sortable: true,
        },
        {
          key: "ejector",
          label: "Ejektor",
          sortable: true,
        },
        {
          key: "flushpressure",
          label: "Spyletrykk",
          sortable: false,
        },
        {
          key: "oxygen",
          label: "Oksygen",
          sortable: false,
        },
        {
          key: "fishcount",
          label: "Antall fisk",
          sortable: false,
        },
        {
          key: "comment",
          label: "Kommentar",
          sortable: true,
          tdClass: "flscellmaxwidth",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [25, 50, 100, 250, 500, 1000],
      sortBy: "created",
      sortDesc: true,
      sortDirection: "desc",
      filter: null,
      limit: 1000,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sumFlushlogsTotal() {
      return this.flushlogs.length;
    },
  },
  methods: {
    getFLS() {
      this.isLoading = true;
      var company = localStorage.getItem("company");

      axios
        .get("https://api.eines-as.no/fls?_limit=-1&_sort=createdAt:DESC&_where[company]=" + company)
        .then((res) => {
          this.flushlogs = res.data;
          this.totalRows = this.flushlogs.length
          this.isLoading = false;
        });
    },
    updateFlushlogs() {
      this.isLoading = true;

      var company = localStorage.getItem("company");

      axios
        .get("https://api.eines-as.no/fls?_limit=-1&_sort=createdAt:DESC&_where[company]=" + company)
        .then((res) => {
          this.flushlogs = res.data;
          this.totalRows = this.flushlogs.length
          this.isLoading = false;
        });
    },
    rowCompleted(item, type) {
      if (!item || type !== "row") return;
      if (item.completed == true) return "table-success";
    },
  },
  created: function () {
    this.getFLS();
  },
};
</script>

<style lang="css">
.country-flag {
  max-width: 20px;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
}

.flscellmaxwidth {
  max-width: 300px;
}

/*
 * Link
 */

/* Links */

.link {
  color: #484848;
}

/* unvisited link */
.link:link {
  color: #484848 !important;
}

/* visited link */
.link:visited {
  color: #484848 !important;
}

/* mouse over link */
.link:hover {
  color: #6e6e6e !important;
}

/* selected link */
.link:active {
  color: #484848 !important;
}

.table .table-success,
.table .table-success > th,
.table .table-success > td {
  background-color: #e4fae9;
}
</style>